import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
import { TooltipEl } from 'common/components/tooltip';
export function template() {
  return jsx("div", {
    sel: '.mp-input-label-container'
  }, jsx("label", {
    sel: '.mp-input-label',
    attrs: {
      for: this.attr("field-id")
    }
  }, this.attr("label")), this.attr("necessary") ? jsx("span", {
    sel: '.mp-input-necessary'
  }, this.attr("necessary")) : null, this.attr("help-text") ? jsx("div", {
    sel: '.mp-input-help-icon'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "info"
    }
  }), jsx(TooltipEl, {
    attrs: {
      'max-width': "500px"
    }
  }, this.attr("help-text"))) : null, this.attr("extra-info") ? jsx("div", {
    sel: '.mp-input-extra-info'
  }, this.attr("extra-info")) : null);
}